import {post} from "../webservice";
import {alert} from "@/js/alert/alert";
import store from '@/store/index'

export const category = {
    namespaced: true,
    state: {
        categories: [],
    },
    mutations: {
        set(state, categories) {
            state.categories = categories
        },
    },
    getters: {
        get(state) {
            return state.categories
        },
        getItem: (state) => (id) => {
            return state.categories.find(item => item.id == id);
        }
    },
    actions: {
        async getList(context) {
            const id = store.getters["catalog/getItemId"]

            await post('v1/catalog/category/getList', {catalog_id: id})
                .then(function (response) {
                    if (response.data.code === 200) {
                        context.commit('set', response.data.data.categories);
                    } else {
                        alert('error', response.data.description)
                    }
                })
                .catch(function (error) {
                    alert('error', error)
                })
        }
    }
}